import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { comics } from '@/mocks/comics';
import { categories } from '@/mocks/categories';

const coverUrls: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20epic%20scene%20of%20solo%20hunter%20with%20glowing%20blue%20energy%2C%20dark%20dungeon%20atmosphere%2C%20dynamic%20action%20composition%2C%20cinematic%20lighting%2C%20Korean%20digital%20illustration%2C%20professional%20art%20style%2C%20dramatic%20mood&width=800&height=450&seq=article-hero-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20scene%2C%20beautiful%20campus%20with%20cherry%20blossoms%2C%20young%20couple%20romantic%20moment%2C%20soft%20pastel%20lighting%2C%20Korean%20digital%20art%2C%20shojo%20style%20illustration&width=800&height=450&seq=article-hero-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20apocalyptic%20scene%2C%20protagonist%20in%20destroyed%20city%2C%20mysterious%20constellations%20in%20sky%2C%20dramatic%20lighting%2C%20Korean%20digital%20art%2C%20epic%20scale%2C%20action%20adventure&width=800&height=450&seq=article-hero-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20scene%2C%20elegant%20queen%20in%20grand%20palace%20throne%20room%2C%20golden%20ornate%20decorations%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20royal%20atmosphere&width=800&height=450&seq=article-hero-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Korean%20urban%20drama%20scene%2C%20contrasting%20dual%20identity%20concept%2C%20high%20school%20setting%2C%20modern%20Korean%20city%20background%2C%20dramatic%20lighting%2C%20Korean%20digital%20art%2C%20realistic%20style&width=800&height=450&seq=article-hero-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Korean%20horror%20thriller%20scene%2C%20dark%20apartment%20corridor%20with%20ominous%20shadows%2C%20tense%20survival%20atmosphere%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20horror%20manga%20style&width=800&height=450&seq=article-hero-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20palace%20scene%2C%20young%20princess%20with%20emperor%20father%2C%20warm%20golden%20lighting%2C%20royal%20garden%20setting%2C%20Korean%20digital%20illustration%2C%20beautiful%20fantasy%20art&width=800&height=450&seq=article-hero-7&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20action%20scene%2C%20fierce%20warrior%20battle%2C%20dynamic%20combat%20pose%2C%20intense%20energy%2C%20dramatic%20lighting%2C%20Korean%20digital%20illustration%2C%20epic%20fight%20scene&width=800&height=450&seq=article-hero-8&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=Korean%20urban%20business%20scene%2C%20confident%20man%20in%20modern%20office%20building%2C%20city%20skyline%20view%2C%20professional%20atmosphere%2C%20Korean%20digital%20art%2C%20drama%20style&width=800&height=450&seq=article-hero-9&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20scene%2C%20four%20teenage%20girls%20laughing%20together%20in%20classroom%2C%20warm%20sunlight%2C%20friendship%20theme%2C%20Korean%20digital%20illustration%2C%20heartwarming%20atmosphere&width=800&height=450&seq=article-hero-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20scene%2C%20tough%20man%20making%20funny%20face%20with%20cute%20baby%2C%20bright%20living%20room%2C%20humorous%20mood%2C%20colorful%20Korean%20digital%20art%2C%20playful%20illustration&width=800&height=450&seq=article-hero-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20adventure%20scene%2C%20mysterious%20tower%20interior%20with%20magical%20elements%2C%20epic%20scale%2C%20young%20hero%20climbing%2C%20Korean%20digital%20illustration%2C%20cinematic%20fantasy%20art&width=800&height=450&seq=article-hero-12&orientation=landscape',
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const comic = comics.find((c) => c.id === parseInt(id || '0'));
  const category = categories.find((c) => c.slug === comic?.category);

  if (!comic) {
    return (
      <>
        <Navbar />
        <div className="pt-20 px-6 text-center py-32">
          <h1 className="text-2xl font-bold">漫画不存在</h1>
          <Link to="/" className="text-primary-500 mt-4 inline-block">返回首页</Link>
        </div>
        <Footer />
      </>
    );
  }

  const relatedComics = comics
    .filter((c) => c.category === comic.category && c.id !== comic.id)
    .slice(0, 3);

  const reviews = [
    { name: '追漫达人', rating: 5, content: '这部漫画真的太上头了！画风精美，剧情紧凑，一口气看了50话停不下来，强烈推荐给所有韩漫爱好者！' },
    { name: '深夜读者', rating: 5, content: '作者的画功真的太强了，每一格都像插画一样精致。故事节奏把控得也很好，期待后续剧情发展。' },
    { name: '漫画评鉴师', rating: 4, content: '整体质量很高，人物塑造丰满立体，世界观构建也很完整。少数章节节奏稍慢，但瑕不掩瑜。' },
  ];

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: `${comic.title} - 炮渣漫画网`,
    description: comic.description,
    author: { '@type': 'Person', name: comic.author },
    url: `http://pepmayans.com/article/${comic.id}`,
    publisher: { '@type': 'Organization', name: '炮渣漫画网' },
    datePublished: '2025-01-15',
    dateModified: '2026-07-01',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: `${comic.title}是免费的吗？`, acceptedAnswer: { '@type': 'Answer', text: `是的，${comic.title}在炮渣漫画网上完全免费阅读，无需付费即可畅享全部${comic.chapters}话内容。` } },
      { '@type': 'Question', name: `${comic.title}多久更新一次？`, acceptedAnswer: { '@type': 'Answer', text: `目前${comic.title}为${comic.status}状态，更新频率稳定，炮渣漫画网会第一时间同步最新章节。` } },
      { '@type': 'Question', name: `${comic.title}适合什么年龄段的读者？`, acceptedAnswer: { '@type': 'Answer', text: `${comic.title}属于${category?.name || comic.category}类型，适合喜欢该类题材的读者阅读。` } },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://pepmayans.com/' },
      { '@type': 'ListItem', position: 2, name: category?.name || '分类', item: `http://pepmayans.com/category/${comic.category}` },
      { '@type': 'ListItem', position: 3, name: comic.title },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
          <img
            src={coverUrls[comic.id] || coverUrls[1]}
            alt={comic.title}
            title={`${comic.title} - 韩国漫画`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

          <div className="relative z-10 w-full h-full flex flex-col justify-end px-6 md:px-10 pb-10">
            <div className="pt-20">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
                {comic.title}
              </h1>
              <div className="flex flex-col md:flex-row gap-4 md:gap-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3">
                  <p className="text-white/80 text-xs mb-1">评分</p>
                  <p className="text-white font-semibold text-sm">{comic.rating} / 10</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg px-5 py-3 md:mt-6">
                  <p className="text-white/80 text-xs mb-1">状态</p>
                  <p className="text-white font-semibold text-sm">{comic.status} · {comic.chapters}话</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: category?.name || '分类', to: `/category/${comic.category}` },
            { label: comic.title },
          ]} />
        </div>

        {/* Details */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
            <div className="flex flex-col lg:flex-row gap-12">
              <div className="lg:w-2/3">
                <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 border border-primary-200/60 px-3 py-1 rounded-full mb-4">
                  作品详情
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 leading-tight mb-8">
                  {comic.title}
                  <br />
                  <span className="text-foreground-500">剧情简介</span>
                </h2>
                <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-8">
                  {comic.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-8">
                  {comic.tags.map((tag) => (
                    <span key={tag} className="bg-secondary-100 text-secondary-800 text-xs px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                  <button type="button" className="bg-primary-500 hover:bg-primary-600 text-white font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors">
                    开始阅读
                  </button>
                  <button type="button" className="border border-foreground-300 text-foreground-700 hover:border-foreground-500 font-medium px-8 py-3 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors">
                    加入书架
                  </button>
                </div>

                <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-6">
                  <div>
                    <p className="text-xs text-foreground-400 mb-1">作者</p>
                    <p className="font-semibold text-foreground-800 text-sm">{comic.author}</p>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-1">总话数</p>
                    <p className="font-semibold text-foreground-800 text-sm">{comic.chapters}话</p>
                  </div>
                  <div>
                    <p className="text-xs text-foreground-400 mb-1">阅读量</p>
                    <p className="font-semibold text-foreground-800 text-sm">{comic.views}</p>
                  </div>
                </div>
              </div>

              <div className="lg:w-1/3">
                <div className="bg-background-100 rounded-2xl p-6">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">作品信息</h3>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between">
                      <span className="text-foreground-500">分类</span>
                      <span className="text-foreground-800">{category?.name || comic.category}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-foreground-500">状态</span>
                      <span className="text-foreground-800">{comic.status}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-foreground-500">评分</span>
                      <span className="text-accent-600 font-semibold">{comic.rating}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-foreground-500">阅读量</span>
                      <span className="text-foreground-800">{comic.views}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="py-14 md:py-20 bg-secondary-50">
          <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs font-medium text-accent-600 bg-accent-50 border border-accent-200/60 px-3 py-1 rounded-full">
                  读者书评
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                大家对这部漫画的评价
              </h2>
              <p className="text-foreground-600 text-sm max-w-[480px] mx-auto">
                来自炮渣漫画网读者的真实反馈
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {reviews.map((review, index) => (
                <div key={index} className={`bg-background-50 rounded-xl p-6 ${index === reviews.length - 1 ? 'opacity-60' : ''}`}>
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <h4 className="font-heading font-bold text-foreground-900 mb-3 text-sm">
                    {review.name}的评价
                  </h4>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {review.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Related */}
        {relatedComics.length > 0 && (
          <section className="py-14 md:py-20 bg-background-50">
            <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10">
                <div>
                  <h2 className="font-label text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-2">
                    相关推荐
                  </h2>
                  <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 italic">
                    猜你喜欢
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 max-w-[400px]">
                  根据分类和阅读偏好为您推荐更多精彩漫画
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {relatedComics.map((c, index) => (
                  <Link
                    key={c.id}
                    to={`/article/${c.id}`}
                    className={`group block rounded-2xl overflow-hidden transition-all duration-300 ${
                      index === 1 ? 'bg-primary-800' : 'bg-background-100'
                    }`}
                  >
                    <div className="relative aspect-[3/4] overflow-hidden rounded-t-2xl">
                      <img
                        src={coverUrls[c.id] || coverUrls[1]}
                        alt={c.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      />
                      <div className="absolute top-3 left-3">
                        <span className="bg-secondary-500 text-foreground-950 text-xs font-bold px-2.5 py-1 rounded-full">
                          {category?.name || c.category}
                        </span>
                      </div>
                    </div>
                    <div className={`p-5 ${index === 1 ? 'text-white' : ''}`}>
                      <h3 className={`font-heading text-lg font-bold mb-2 line-clamp-2 ${index === 1 ? 'text-white' : 'text-foreground-900'}`}>
                        {c.title}
                      </h3>
                      <p className={`text-xs ${index === 1 ? 'text-white/60' : 'text-foreground-500'}`}>
                        {c.author} · {c.status}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}